<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogEventVisible" :width="LeveWidth + 'px'" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" :label-width="formLabelWidth + 'px'" @submit.native.prevent>
            <el-row>
                <el-col span="12">
                    <el-form-item :label="$t('common.ALARM_SERIAL_NUMBER')" prop="sId">
                        <td-input v-model="formInfo.sId" :disabled="sIdDisabled" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
                <el-col span="12">
                    <el-form-item :label="$t('common.NAME')" prop="sName">
                        <td-input v-model="formInfo.sName" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col span="12">
                    <el-form-item :label="$t('common.ALARM_SOURCE')" prop="iAlarmSourceType" required>
                        <td-select v-model="formInfo.iAlarmSourceType" :clearable="false" @change="sourceTypeChange" :options="alarmSourceList" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                    </el-form-item>
                </el-col>
                <el-col span="12">
                    <el-form-item :label="$t('pgCommon.ALARM_GROUP')" prop="sAlarmTypeId">
                        <td-tree-select
                            ref="TdAlarmTypeTree"
                            :treeList="alarmTypeList"
                            :lazyloading="lazyloading"
                            :defaultProps="defaultProps"
                            :isSingleCheck="isSingleCheck"
                            :inputShow="inputShow"
                            :nodeKey="nodeKey"
                            :expandAll="expandAll"
                            :multiple="false"
                            :refreshIconShowSel="false"
                        ></td-tree-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="isDeviceAlarm">
                <el-col span="12">
                    <el-form-item :label="$t('common.ALARM_LEVEL')" prop="sAlarmLevelId">
                        <td-select v-model="formInfo.sAlarmLevelId" :clearable="false" keys="sId" text="sName" :options="alarmLevelList" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                    </el-form-item>
                </el-col>
                <el-col span="12">
                    <el-form-item :label="$t('common.DEVICE_TYPE')" prop="sDeviceTypeId">
                        <td-select
                            v-model="formInfo.sDeviceTypeId"
                            keys="iId"
                            text="sName"
                            multiple="true"
                            collapse-tags="true"
                            :options="deviceTypeList"
                            :placeholder="$t('common.PLEASE_SELECT')"
                        ></td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('pgCommon.TYPE_SUB')" v-if="isDeviceAlarm">
                <td-button type="primary" size="mini" @click.native="addEventSub">{{ $t('common.ADD') }}</td-button>
                <td-button type="button" size="mini" @click.native="deleteEventSub">{{ $t('common.DELETE') }}</td-button>
            </el-form-item>
            <el-form-item v-if="isDeviceAlarm">
                <!-- 加载联动动作表格 -->
                <td-table
                    :columns="eventSubColumns"
                    max-height="200"
                    :hasPage="false"
                    :hasIndex="false"
                    :dataSource="eventSubData"
                    :hasMutiSelect="true"
                    :hasLoading="loading"
                    ref="eventSubTable"
                    rowKey="sId"
                ></td-table>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
        <!-- 加载二级事件dialog -->
        <dialog-eventSub
            v-if="dialogEventSubVisible"
            :dialogEventSubVisible="dialogEventSubVisible"
            :isAddData="isEventSubAddData"
            :editItem="eventSubEeditItem"
            :title="eventSubTitle"
            @dialogClose="dialogClose"
            @saveEventSubInfo="saveEventSubInfo"
        ></dialog-eventSub>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
import dialogEventSub from './dialogEventSub.vue';
export default {
    props: ['title', 'dialogEventVisible', 'editItem', 'isAddData', 'sIdDisabled'],
    // 初始化渲染
    components: {
        'dialog-eventSub': dialogEventSub
    },
    created() {
        this.initSelect();
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.LeveWidth = 630 + (Number(newVal) == 14 ? 0 : Number(newVal) + 120);
                this.formLabelWidth = 95 + (Number(newVal) == 14 ? 0 : Number(newVal) + 30);
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        let validateSId = (rule, value, callback) => {
            if (!this.isAddData) {
                callback();
                return;
            }
            let param = {
                sId: value,
                isAddData: this.isAddData
            };
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(response.data.statusMessage);
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        let validateSName = (rule, value, callback) => {
            let param = {
                sName: value,
                isAddData: this.isAddData
            };
            if (!this.isAddData) {
                param.sId = this.editItem.sId;
            }
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(response.data.statusMessage);
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            formLabelWidth: 95,
            LeveWidth: 630,
            // 表单信息
            formInfo: {
                sId: '',
                sName: '',
                sPrimaryId: '',
                iAlarmSourceType: window.pangu.common.alarmSource.device
            },
            alarmSourceList: window.pangu.common.alarmSourceList,
            alarmLevelList: [],
            alarmTypeList: [],
            deviceTypeList: [],
            eventSubData: [],
            lazyloading: false,
            dialogEventSubVisible: false,
            isSingleCheck: true,
            inputShow: false,
            saveLoading: false,
            nodeKey: 'id',
            expandAll: true,
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id'
            },
            eventSubColumns: [
                {
                    prop: 'sNumber',
                    label: this.$t('common.ALARM_SERIAL_NUMBER')
                },
                {
                    prop: 'sName',
                    label: this.$t('common.NAME')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmSubscribeGroup:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmSubscribeGroup:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ],
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('pgRegex.PLEASE_INPUT_CREDENT_NUM_RESET') },
                    { validator: validateSName, trigger: 'blur' }
                ],
                sId: [
                    { required: true, message: this.$t('pgRegex.PLEASE_ENTER_SERIAL_NUMBER_ALARM_EVENT'), trigger: 'blur' },
                    { pattern: this.$regex.NUM, message: this.$t('pgRegex.SERIAL_NUMBER_ILLEGAL_AlARM_EVENT') },
                    { validator: validateSId, trigger: 'blur' }
                ],
                sAlarmLevelId: [{ required: true, message: this.$t('error.ERROR_ALARM_LEVEL_NULL'), trigger: 'change' }]
            },
            isDeviceAlarm: true
        };
    },
    // 定义并实现方法体
    methods: {
        initSelect() {
            api.getAlarmLevel('{}', response => {
                this.alarmLevelList = response.data.content;
            });
            api.getDeviceTypeList('', response => {
                this.deviceTypeList = response.data.content;
            });
            api.getAlarmTypeTree('', response => {
                this.alarmTypeList = response.data.content;
            });
        },
        // 初始化编辑数据
        initEditData() {
            this.formInfo.sName = this.editItem.sName;
            this.formInfo.sId = this.editItem.sId;
            this.formInfo.sAlarmLevelId = this.editItem.sAlarmLevelId;
            this.formInfo.sPrimaryId = this.editItem.sPrimaryId;
            this.formInfo.iAlarmSourceType = this.editItem.iAlarmSourceType;
            if (this.formInfo.iAlarmSourceType == window.pangu.common.alarmSource.business) {
                this.isDeviceAlarm = false;
            }
            this.initAlarmType();
            this.initEventSub();
            if (this.editItem.sDeviceTypeList) {
                this.formInfo.sDeviceTypeId = this.editItem.sDeviceTypeList;
            }
        },
        // 初始化报警类型
        initAlarmType: function() {
            this.$nextTick(function() {
                if (this.editItem.sAlarmTypeId && this.editItem.sAlarmTypeId !== '' && this.editItem.sAlarmTypeName !== '') {
                    let obj = {};
                    obj.typeName = this.editItem.sAlarmTypeName;
                    obj.id = this.editItem.sAlarmTypeId;
                    this.$refs.TdAlarmTypeTree.dataDisplay([obj]);
                }
            });
        },
        //初始化二级事件
        initEventSub() {
            api.getAlarmEventSub(this.editItem.sId, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getAlarmEventSub', response.data.statusMessage);
                    return;
                }
                this.eventSubData = response.data.content;
            });
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    let alarmTypeNode = this.$refs.TdAlarmTypeTree.getSelectedNodes();
                    let content = {
                        sName: this.formInfo.sName,
                        sId: this.formInfo.sId,
                        sPrimaryId: this.formInfo.sPrimaryId,
                        sAlarmLevelId: this.formInfo.sAlarmLevelId,
                        sAlarmTypeId: alarmTypeNode ? alarmTypeNode.id : '',
                        iAlarmSourceType: this.formInfo.iAlarmSourceType,
                        sDeviceTypeList: this.formInfo.sDeviceTypeId,
                        alarmEventSubList: this.eventSubData,
                        isAddData: this.isAddData
                    };
                    api.saveAlarmEvent(content, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/saveAlarmEvent', response.data.statusMessage);
                            this.saveLoading = false;
                            return;
                        }
                        this.saveLoading = false;
                        let message = this.$t('common.ADD_SUCCESS');
                        if (!this.isAddData) {
                            message = this.$t('common.MODIFY_SUCCESS');
                        }
                        this.$message({ showClose: true, message: message, type: 'success' });
                        this.eventDialogClose();
                    });
                }
            });
        },
        //添加二级事件
        addEventSub() {
            this.eventSubTitle = this.$t('common.ADD') + this.$t('pgCommon.TYPE_SUB'); // 标题
            this.isEventSubAddData = true;
            this.dialogEventSubVisible = true;
        },
        // 编辑二级事件
        btnEdit(row) {
            this.eventSubEeditItem = row;
            this.eventSubTitle = this.$t('common.EDIT') + this.$t('pgCommon.TYPE_SUB'); // 标题
            this.isEventSubAddData = false;
            this.dialogEventSubVisible = true;
        },
        //批量删除二级事件
        deleteEventSub() {
            let eventSubList = this.$refs.eventSubTable.getSelectAllRows();
            if (eventSubList.length == 0) {
                this.$message({ showClose: true, message: this.$t('pgMessage.SELECT_AT_LEAST_ONE_TYPE_SUB_MESSAGE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let sIdArr = [];
                    for (let i = 0; i < eventSubList.length; i++) {
                        sIdArr.push(eventSubList[i].sId);
                    }
                    for (let i = 0; i < this.eventSubData.length; i++) {
                        let eventSub = this.eventSubData[i];
                        if (sIdArr.indexOf(eventSub.sId) >= 0) {
                            this.eventSubData.splice(i, 1);
                            i--;
                        }
                    }
                    this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                })
                .catch(() => {});
        },
        //保存二级事件
        saveEventSubInfo(value) {
            //校验二级事件是否重复
            for (let i = 0; i < this.eventSubData.length; i++) {
                let eventSub = this.eventSubData[i];
                if (value.sId) {
                    if (value.sId != eventSub.sId) {
                        if (eventSub.sNumber === value.sNumber) {
                            this.$message({ showClose: true, message: this.$t('pgMessage.TYPE_SUB_NUMBER_EXIST_PLEASE_INPUT'), type: 'warning' });
                            return;
                        }
                        if (eventSub.sName === value.sName) {
                            this.$message({ showClose: true, message: this.$t('pgMessage.TYPE_SUB_NAME_EXIST_PLEASE_INPUT'), type: 'warning' });
                            return;
                        }
                    }
                } else {
                    if (eventSub.sNumber === value.sNumber) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.TYPE_SUB_NUMBER_EXIST_PLEASE_INPUT'), type: 'warning' });
                        return;
                    }
                    if (eventSub.sName === value.sName) {
                        this.$message({ showClose: true, message: this.$t('pgMessage.TYPE_SUB_NAME_EXIST_PLEASE_INPUT'), type: 'warning' });
                        return;
                    }
                }
            }
            //若为修改二级事件
            if (value.sId) {
                let flag = true;
                for (let i = 0; i < this.eventSubData.length; i++) {
                    let eventSub = this.eventSubData[i];
                    if (eventSub.sId === value.sId) {
                        this.eventSubData.splice(i, 1, value);
                        flag = false;
                        break;
                    }
                }
                if (flag) {
                    this.eventSubData.push(value);
                }
            } else {
                value.sId = new Date().getTime();
                this.eventSubData.push(value);
            }
            this.dialogClose();
        },

        // 删除二级事件
        btnDelete(sId) {
            if (sId) {
                this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                    confirmButtonText: this.$t('common.SURE'),
                    cancelButtonText: this.$t('common.CANCEL'),
                    type: 'warning'
                })
                    .then(() => {
                        for (let i = 0; i < this.eventSubData.length; i++) {
                            let eventSub = this.eventSubData[i];
                            if (eventSub.sId === sId) {
                                this.eventSubData.splice(i, 1);
                                break;
                            }
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                    })
                    .catch(() => {});
            }
        },
        /* 报警源类型监听 */
        sourceTypeChange(val) {
            this.isDeviceAlarm = val == window.pangu.common.alarmSource.device ? true : false;
        },
        // 取消
        cancel() {
            this.$emit('eventDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
        },
        // 关闭窗口之前需要调用的方法
        eventDialogClose() {
            this.cancel();
            this.$emit('submit');
        },
        // 关闭二级事件
        dialogClose() {
            this.dialogEventSubVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
